import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
      api_url: '',
      api_token: '',
      current_component: '',
      current_component_props: {},
      order_reference: '',
      order: null,
      providers: [{id:0,title:'Anderer'}],
      ApiService: null,
  },
  mutations: {
      api_url: function(state, value){
          state.api_url = value;
      },
      api_token: function(state, value){
          state.api_token = !value ? '' : value;
      },
      current_component: function(state, value){
          state.current_component       = value.component;
          state.current_component_props = value.props;
      },
      order: function(state, value){
          state.order = value;
      },
      order_reference: function(state, value){
          state.order_reference = value;
      },
      providers: function(state, value){
          state.providers = value;
      },
      ApiService: function(state, value){
          value.container = this;
          state.ApiService = value;
      },
  },
  actions: {

  }
})
